module.exports = __webpack_public_path__ + "static/media/backgroundImage-dark.cd1e60d3.jpeg";